import { WallData } from '@/editor/data/wall/Wall';
import { Point2dUtils } from '@/editor/math/Point2dUtils';
import { equalsNumber } from '@/editor/math/utils';
import { constructRectRoomWalls } from '../room';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { ESeparateWallType } from '@/editor/data/separateWall/SeparateWall';
import { EVirtualWallStyle } from '@/editor/entities/2d/virtualWallModel';

export function equalsWallData(wallData1: WallData, wallData2: WallData) {
  const baseData1 = wallData1.baseData;
  const baseData2 = wallData2.baseData;
  if (
    Point2dUtils.equals(baseData1.start, baseData2.start) &&
    Point2dUtils.equals(baseData1.end, baseData2.end) &&
    equalsNumber(baseData1.thickness, baseData2.thickness) &&
    equalsNumber(baseData1.height, baseData2.height) &&
    equalsNumber(baseData1.offGround, baseData2.offGround)
  ) {
    return true;
  }

  return false;
}

export function getRectVirtualWalls(start: IPoint2d, end: IPoint2d, thickness: number) {
  const points = constructRectRoomWalls(start, end);
  return points.reverse().map((point, index) => ({
    start: point,
    end: points[(index + 1) % points.length],
    thickness
  }));
}

export function convertSepWallTypeToVirtualWallStyle(wallType: ESeparateWallType): EVirtualWallStyle {
  switch (wallType) {
    case ESeparateWallType.GlassWall:
      return EVirtualWallStyle.GlassSepWall;
    case ESeparateWallType.HalfGlassWall:
      return EVirtualWallStyle.HalfGlassSepWall;
    case ESeparateWallType.VirtualWall:
      return EVirtualWallStyle.VirtualSepWall;
    default:
      return EVirtualWallStyle.SepWall;
  }
}

/**
 * convertSepWallTypeToVirtualWallStyle 的逆映射，将虚拟墙样式还原为隔墙类型。
 */
export function styleToSepWallType(style?: EVirtualWallStyle): ESeparateWallType {
  switch (style) {
    case EVirtualWallStyle.GlassSepWall:
      return ESeparateWallType.GlassWall;
    case EVirtualWallStyle.HalfGlassSepWall:
      return ESeparateWallType.HalfGlassWall;
    case EVirtualWallStyle.VirtualSepWall:
      return ESeparateWallType.VirtualWall;
    default:
      return ESeparateWallType.SolidTabletWall;
  }
}
